import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

// Mirror of Worksnip's authStore, with persist key `notologic.auth`.

export interface AuthUser {
  id: string;
  email: string;
  display_name: string;
  role: 'owner' | 'admin' | 'member' | 'viewer';
  is_super_admin: boolean;
}

export interface AuthOrg {
  id: string;
  name: string;
  slug: string;
}

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  org: AuthOrg | null;
  setSession: (token: string, user: AuthUser, org: AuthOrg) => void;
  logout: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      org: null,
      setSession: (token, user, org) => set({ token, user, org }),
      logout: () => set({ token: null, user: null, org: null }),
    }),
    {
      name: 'notologic.auth',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
